export function productValidate(product){
    var result = true;

    result = validateId(product.id);
    result = validateSku(product.sku);
    result = validateDescription(product.description);
    result = validateStoragePolicy(product.storage_policy);
    result = validateWeight(product.weight);
    result = validateIsNational(product.is_national);
    result = validateUnit(product.unit);
    result = validateBarcode(product.barcode);
    result = validateHeight(product.height);
    result = validateLength(product.length);
    result = validateWidth(product.width);
    result = validateSizeUnit(product.size_unit);
    result = validateCategory(product.category);
    result = validateClient(product.client);
    result = validateDetailedStocks(product.detailed_stock);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateSku(sku){
    if(typeof sku === 'string' && sku.trim() !== '') return true;
    else return false;
}

function validateDescription(description){
    if(typeof description === 'string' || description.trim() !== '') return true;
    else return false;
}

function validateStoragePolicy(storage_policy){
    if(typeof storage_policy === 'number' || storage_policy == null) return true;
    else return false;
}

function validateWeight(weight){
    if(typeof weight === 'number' || weight == null) return true;
    else return false;
}

function validateIsNational(is_national){
    if(typeof is_national === 'boolean') return true;
    else return false;
}

function validateUnit(unit){
    if(typeof unit === 'string' || unit.trim() !== '') return true;
    else return false;
}

function validateBarcode(barcode){
    if(barcode == null || typeof barcode === 'string' || barcode.trim() !== '') return true;
    else return false;
}

function validateHeight(height){
    if(height == null || typeof height === 'number' || height.trim() !== '') return true;
    else return false;
}

function validateLength(length){
    if(length == null || typeof length === 'number' || length.trim() !== '') return true;
    else return false;
}

function validateWidth(width){
    if(width == null || typeof width === 'number' || width.trim() !== '') return true;
    else return false;
}

function validateSizeUnit(size_unit){
    if(size_unit == null || typeof size_unit === 'string' || size_unit.trim() !== '') return true;
    else return false;
}

function validateClient(client){
    if(typeof client.name !== 'string' || client.name.trim() === '') return false;
    if(typeof client.id !== 'number' || client.id.toString().trim() === '') return false;

    return true;
}

function validateCategory(category){
    if(typeof category.name !== 'string' || category.name.toString().trim() === '') return false;
    if(typeof category.description !== 'string' || category.description.trim() === '') return false;
    if(typeof category.id !== 'number' || category.id.toString().trim() === '') return false;

    return true;
}

function validateDetailedStocks(detailed_stock){
    return Array.isArray(detailed_stock) 
        // && detailed_stocks.length > 0 
        //  && products.every(item =>
        // typeof item === 'object' &&
        // item !== null &&
        // typeof item.id === 'number' &&
        // !isNaN(item.id) &&
        // typeof item.quantity === 'number' &&
        // !isNaN(item.quantity)&&
        // typeof item.unit_price === 'number' &&
        // !isNaN(item.unit_price)
        // );
}